/* eslint-disable react/jsx-props-no-multi-spaces */
/* eslint-disable react/require-default-props */
/* eslint-disable react/forbid-prop-types */
import PropTypes from "prop-types";
import Desktop from "./desktop";

const SideMenu = ({
	query,
	title,
	filter,
	className,
	brandsMenu,
	productsMenu,
	extractParCat,
	handleFilterDesktop,
	handleFilterRemove,
}) => (
	<Desktop
		query={query}
		title={title}
		filter={filter}
		className={className}
		brandsMenu={brandsMenu}
		productsMenu={productsMenu}
		extractParCat={extractParCat}
		handleFilterDesktop={handleFilterDesktop}
		handleFilterRemove={(HandleType, val) => handleFilterRemove(HandleType, val)}
	/>
);

SideMenu.propTypes = {
	query: PropTypes.any,
	filter: PropTypes.any,
	title: PropTypes.string,
	productsMenu: PropTypes.any,
	brandsMenu: PropTypes.array,
	className: PropTypes.string,
	extractParCat: PropTypes.any,
	handleFilterRemove: PropTypes.func,
	handleFilterDesktop: PropTypes.func,
};

export default SideMenu;
